/** Alineado con `BarcodeScannerModal` para evitar doble disparo cámara/HID. */
export const BARCODE_SCAN_LOCK_MS = 1200;

/** Lock entre lecturas del multi-scan (evita eco del mismo disparo). */
export const BARCODE_INTER_READ_LOCK_MS = 250;

/** Fallback después de N mismatches consecutivos en multi-scan. */
export const BARCODE_MULTI_SCAN_MAX_MISMATCHES = 3;

/** MVP: códigos numéricos tipo EAN/UPC (8–14 dígitos) al enviar con Enter desde lector HID. */
export function looksLikeBarcodeHardwareSubmit(raw: string): boolean {
  return /^\d{8,14}$/.test(raw.trim());
}

export type BarcodeScanDedupe = (normalizedCode: string) => boolean;

/** Evita procesar el mismo código dos veces seguidas (lector + eco o doble Enter). */
export function createBarcodeScanDedupe(lockMs: number = BARCODE_SCAN_LOCK_MS): BarcodeScanDedupe {
  let last = { code: '', at: 0 };
  return (code: string) => {
    const c = code.trim();
    const now = Date.now();
    if (last.code === c && now - last.at < lockMs) {
      return false;
    }
    last = { code: c, at: now };
    return true;
  };
}

/**
 * Si el valor del buscador saltó de golpe (cámara / pegado / setState post-scan),
 * hay que seleccionar todo para que el próximo HID reemplace en vez de concatenar.
 * No dispara con tipeo carácter a carácter.
 */
export function shouldSelectAllAfterBarcodeFieldValueChange(prev: string, next: string): boolean {
  const p = prev.trim();
  const n = next.trim();
  if (!n || n === p) return false;
  if (n.length < 6) return false;
  // Reemplazo completo o salto grande (p. ej. "" → EAN, o EAN_A → EAN_B).
  if (p.length === 0) return n.length >= 6;
  if (Math.abs(n.length - p.length) >= 6) return true;
  if (p.length >= 6 && n.length >= 6 && !n.startsWith(p) && !p.startsWith(n)) return true;
  return false;
}
